import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
// import { Workbook } from 'exceljs';
import * as Excel from "exceljs/dist/exceljs.min.js";
import {ReportService} from '../../../repository/service/report.service'

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
const CSV_EXTENSION = '.csv';

@Injectable()
export class ExcelService {

  constructor(
    private reportService:ReportService,
  ) { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    //  window.worksheet = worksheet;
     let cell; 
     for(let key in worksheet) {
        if(worksheet[key] && worksheet[key].v && worksheet[key].v == "S.NO") {
          cell = key
        }
      }
      
      cell = cell && cell[0] || null;
      if(cell != null) {
        let count = 1;
        while(1) {
          if(worksheet.hasOwnProperty("A" + count)) {

            let temp = worksheet[cell + count];
            worksheet[cell + count] = worksheet["A" + count]
            worksheet["A" + count] = temp;
          }
          else {
            break;
          }
          count += 1;
        }

      }


    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public exportJsonAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public exportMultiLevelJsonAsExcelFile(json: any[], excelFileName: string, dataType:string): void {
    // console.log("json is ===>",json)
    const workBook = new Excel.Workbook();
    const workSheet = workBook.addWorksheet('data');
    const workSheetResult = workBook.addWorksheet('result');
    const excelData = [];
    if (this.reportService.sigConfidenceLevel) {
      workSheetResult.addRow([`Result For Significance Test of ${this.reportService.sigComparetype} at ${this.reportService.sigConfidenceLevel} % Confidence Level`]);
      workSheetResult.addRow([])
      workSheet.addRow([`Result For Significance Test of ${this.reportService.sigComparetype} at ${this.reportService.sigConfidenceLevel} % Confidence Level`]);
      workSheet.addRow([])
    }
    Object.keys(json).forEach((key, i) =>{
      const rowH = workSheet.addRow([json[key]["name"]]);
      
      workSheet.addRow([""])

      // Multilevel Header creation
      Object.keys(json[key]['topCutLevel']).forEach((levelKey,lkIndex) => {
        let lrow = [""]
        Object.keys(json[key]).forEach(cutKeys =>{
          if(cutKeys.includes('overall')){
            if ( lkIndex == 0) {
              lrow.push(cutKeys);
            }else{
              lrow.push("");
            }
          }
        })
        json[key]['topCutLevel'][levelKey].forEach((level,lIndex) => {
          lrow.push(level.name);
          if (level.total) {
            for (let i = 1; i < level.total; i++){
              lrow.push("");            
            }
          }
        });
        workSheet.addRow(lrow);
      });
      workSheet.addRow([""])

      // data insertion 
      json[key]['rows'].forEach((rowKey, ri) => {
        let drow = [rowKey["v"]];
        // let drow = [rowKey];
        let colGap = 2;
        Object.keys(json[key]).forEach(cutKeys =>{
          if(cutKeys.includes('overall')){
            colGap = colGap+1
            drow.push(dataType == 'abs' ? json[key][cutKeys][ri]['v'] : dataType == 'pct' ? (json[key][cutKeys][ri]['np'] ? json[key][cutKeys][ri]['v'] : json[key][cutKeys][ri]['p'] + ' %' ) : (json[key][cutKeys][ri]['np'] ? json[key][cutKeys][ri]['v'] : json[key][cutKeys][ri]['v'] + ' (' + json[key][cutKeys][ri]['p'] + ' %)') )
          }
        })
        json[key]['topCutLevel']['level '+json[key]['topLen']['totalLevels']].forEach((column, ci) => {
          let tempData = dataType == 'abs' ? json[key]['data'][column['index']][ri]['v'] : dataType == 'pct' ? (json[key]['data'][column['index']][ri]['np'] ? json[key]['data'][column['index']][ri]['v'] : json[key]['data'][column['index']][ri]['p'] + ' %') : (json[key]['data'][column['index']][ri]['np'] ? json[key]['data'][column['index']][ri]['v'] : json[key]['data'][column['index']][ri]['v'] +' ('+ json[key]['data'][column['index']][ri]['p'] + ' %)')
          drow.push(tempData)
        });
        const row = workSheet.addRow(drow);
        json[key]['topCutLevel']['level '+json[key]['topLen']['totalLevels']].forEach((column, ci) => {
          if (json[key]['data'][column['index']][ri]['c'] && json[key]['data'][column['index']][ri]['c'] != '') {
            // console.log("colGap is ====>",colGap)
            const col = row.getCell(ci + colGap);
            col.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: json[key]['data'][column['index']][ri]['c'].substring(1) },
            };
          }
        });

        // additional row text in case on among Sig test
        if (json[key]['topLen']['rawtext'].includes(rowKey)) {
          let dtrow = [""];
          Object.keys(json[key]).forEach(cutKeys =>{
            if(cutKeys.includes('overall')){
              dtrow.push("");
            }
          })
          json[key]['topCutLevel']['level '+json[key]['topLen']['totalLevels']].forEach((col, ci) => {
            if (json[key]['data'][col['index']][ri]['text']) {
              dtrow.push(json[key]['data'][col['index']][ri]['text']);
            }else{
              dtrow.push("");
            }
          });
          workSheet.addRow(dtrow);
        }
      });

      if(json[key]['sortResult'] && Object.keys(json[key]['sortResult']).length){
        // workSheet.addRow([]);
        // workSheet.addRow([`Result For Significance Test of ${this.reportService.sigComparetype} at ${this.reportService.sigConfidenceLevel} % Confidence Level`]);
        // workSheet.addRow([]);
        // workSheet.addRow([`Result for ${key}`]);
        // workSheet.addRow([]);
        
        workSheetResult.addRow([]);
        workSheetResult.addRow([json[key]["name"]]);
        // workSheetResult.addRow([key]);
        workSheetResult.addRow([]);
        // workSheetResult.addRow([`Result for ${key}`]);
        workSheetResult.addRow([]);
        Object.keys(json[key]['sortResult']).forEach(rKey =>{
          // workSheet.addRow([rKey]);
          workSheetResult.addRow(["",rKey]);
          json[key]['sortResult'][rKey].forEach(ritem =>{
          //  workSheet.addRow(["",ritem]);
           workSheetResult.addRow(["","",ritem['value']]);
          })
          // workSheet.addRow([]);
          workSheetResult.addRow([]);
        })
      }

      workSheet.addRow([]);
    })
    
    workBook.xlsx.writeBuffer().then((excelBuffer) => {
      this.saveAsExcelFile(excelBuffer, excelFileName);
    });
  }

  public exportTableAsExcelFile(table: HTMLElement, excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
    const row = worksheet.rows;
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, excelFileName, {cellStyles:true});
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    // FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + CSV_EXTENSION);
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // private saveAsXLSXFile(buffer: any, fileName: string): void {
  //   const data: Blob = new Blob([buffer], {
  //     type: EXCEL_TYPE
  //   });
  //   FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  // }
  
}